import {Injectable} from '@angular/core';
import {ComponentBase} from '../component-base';
import {OrbitService} from './orbit.service';


@Injectable()
export class ZoomingDistanceService extends ComponentBase {

  constructor(
    private orbitControl: OrbitService
  ) {
    super();
  }

  enable() {
    super.enable();
    this.orbitControl.enableZoom = true;
  }

  disable() {
    super.disable();
    this.orbitControl.enableZoom = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/services/zooming-distance.service.ts